import { getRecoil, setRecoil } from 'recoil-nexus';

import { clinicalNote, intelligenceAiState } from 'components/state';
import { enhanceNoteLoadingState } from 'components/practice/charts/ClinicalNote/MyScribeAI/state';

// The note a narrative chunk was generated for; null when the backend did not name one.
export const getResponseNoteId = ({ destName, destId }) =>
  destName === 'clinical_note' ? (destId ?? null) : null;

/**
 * Drops a chunk generated for a note other than the open one, releasing its task and loading flag on
 * the final chunk. Returns true when the chunk was dropped.
 */
export const dropOtherNoteResponse = ({ responseNoteId, task_id, form_type, done }) => {
  const openNoteId = getRecoil(clinicalNote)?.id;
  if (responseNoteId == null || String(responseNoteId) === String(openNoteId ?? '')) return false;

  if (done) {
    setRecoil(intelligenceAiState, (ps) => {
      const remaining = ps.activeTaskIds.filter((id) => id !== task_id);
      return { ...ps, activeTaskIds: remaining, loading: remaining.length > 0 };
    });
    setRecoil(enhanceNoteLoadingState, (prev) => prev.filter((n) => n !== form_type));
  }
  return true;
};
